import { CATALOG_RESOURCES } from "@authe/fe-commons/catalog";
import { readEnvKey } from "@authe/fe-commons/env";
import { envSource } from "./env";

/** Build-time knobs; all resource registration stays in the adapter registry. */
export function resolveResourceSyncConfig(source: Record<string, string | boolean | undefined>) {
  const read = (key: string) => readEnvKey(source, `RESOURCE_SYNC_${key}`);
  const enabled = (key: string) => read(key) !== "false";
  const delay = Number(read("DEBOUNCE_MS") ?? 150);
  const resources = read("RESOURCES");
  return {
    enabled: enabled("ENABLED"),
    crossTab: enabled("CROSS_TAB"),
    resources: resources === "none" ? [] : resources === undefined ? [...CATALOG_RESOURCES]
      : resources.split(",").map((s) => s.trim()).filter(Boolean),
    debounceMs: Number.isFinite(delay) ? Math.max(0, Math.min(5000, delay)) : 150,
    revalidateOnFocus: enabled("REVALIDATE_ON_FOCUS"),
    revalidateOnOnline: enabled("REVALIDATE_ON_ONLINE"),
  };
}
export const resourceSyncConfig = resolveResourceSyncConfig(envSource);
